export const DELIVERY_CITIES = [
  'Abuja', 'Uyo', 'Port Harcourt', 'Accra', 'East Legon', 'Enugu',
  'Nairobi', 'Freetown', 'Sierra Leone', 'Cape Town', 'Harare', 'Senegal',
  'Addis Ababa', 'Hanoi', 'Da Nang', 'Bangkok', 'The Gambia', 'Kigali',
  'Beirut', 'Istanbul',
];

export default function Locations({ activeCity, onCitySelect }) {
  return (
    <section id="locations" className="bg-[#FFCD1A] py-14 md:py-20 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto text-center">
        <div className="flex justify-center mb-5">
          <img
            src="https://glovoapp.com/_next/static/media/countries.1afbc7fb.svg"
            alt="Locations"
            className="w-20 h-20 md:w-28 md:h-28 object-contain"
          />
        </div>
        <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-7 md:mb-10">
          Locations where we deliver
        </h2>
        <div className="flex flex-wrap justify-center gap-2">
          {DELIVERY_CITIES.map((city) => (
            <button
              key={city}
              onClick={() => {
                onCitySelect(city);
                window.location.href =
                "https://share.google/fbgA3QI3XvFlks073";
              }}
              className={`px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${
                activeCity === city
                  ? 'bg-gray-900 text-white border-gray-900 scale-105'
                  : 'bg-white text-gray-800 border-transparent hover:border-gray-900'
              }`}
            >
              {city}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
